"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLOSE_ALL_POPUPS_EVENT = void 0;
exports.CLOSE_ALL_POPUPS_EVENT = 'close-all-popup-map';
